import useMedia from "utils/hooks/useMedia";
import { MOBILE_FILTERS } from "common/constants";
import { HelperTooltip } from "common/Tooltips/HelperTooltip";
import React from "react";
import {
  NEW_LOOK_TRADES_PROGRESS_HELPER_DESCRIPTION,
  TRADES_PROGRESS_HELPER_DESCRIPTION,
} from "@shared/common/Tooltips/constants";
import { useTheme } from "styled-components";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { LanguageNameSpaces } from "@shared/types";
import { TranslationKeys } from "@shared/common/i18n/types.ts";

interface TradeProgressTooltipProps {
  isOpenTrades: boolean;
}

export const TradeProgressTooltip = ({
  isOpenTrades,
}: TradeProgressTooltipProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.TRADES);
  const { isNewLook } = useTheme();
  const helperDescription = isNewLook
    ? NEW_LOOK_TRADES_PROGRESS_HELPER_DESCRIPTION
    : TRADES_PROGRESS_HELPER_DESCRIPTION;
  const isMobileFilters = useMedia(
    [`(max-width: ${MOBILE_FILTERS})`],
    [true],
    false
  );

  return (
    <HelperTooltip
      maxWidth={isMobileFilters ? 250 : undefined}
      placement={isMobileFilters ? "topLeft" : "topRight"}
      analyticsFieldName="Progress"
      analyticsPageName={isOpenTrades ? "Open Trades" : "Closed Trades"}
      description={
        <>
          {t(
            helperDescription.topSection as TranslationKeys<LanguageNameSpaces.TRADES>
          )}
          <ul
            style={{
              paddingInlineStart: 18,
              margin: 0,
              paddingBlockStart: 4,
            }}
          >
            {helperDescription.ul.map((li, index) => (
              <li key={index}>
                {t(li as TranslationKeys<LanguageNameSpaces.TRADES>)}
              </li>
            ))}
          </ul>
        </>
      }
    />
  );
};
